import { jsx } from 'react/jsx-runtime';
import { playButtonSound } from '@wg/web2clientapi/sound';
import classNames from 'classnames';
import * as React from 'react';
import styles from './Tabs.module.scss.js';

var TABS_THEMES;
(function (TABS_THEMES) {
    TABS_THEMES["DEFAULT"] = "default";
    TABS_THEMES["CLIENT"] = "client";
})(TABS_THEMES || (TABS_THEMES = {}));
var TABS_SIZES;
(function (TABS_SIZES) {
    TABS_SIZES["S"] = "s";
    TABS_SIZES["M"] = "m";
    TABS_SIZES["L"] = "l";
})(TABS_SIZES || (TABS_SIZES = {}));
var Tabs = function (props) {
    var _a;
    var toggleTab = function (tab) {
        if (tab === props.tabSelected) {
            return;
        }
        props.onToggleTab(tab);
        playButtonSound();
    };
    var tabs = props.tabs.map(function (tab, index) {
        var _a;
        var classNameTab = classNames(styles.tab, (_a = {},
            _a[styles.isSelected] = props.tabSelected === tab.value,
            _a[styles.isUppercase] = props.isUppercase,
            _a[styles.smallHeight] = props.smallHeight,
            _a), props === null || props === void 0 ? void 0 : props.className);
        return (jsx("div", { className: classNameTab, onClick: function () { return toggleTab(tab.value); }, children: jsx("div", { className: styles.tabContent, children: tab.content }) }, "wrui-tab-".concat(String(tab.value))));
    });
    return (jsx("div", { className: classNames(styles.container, (_a = {},
            _a[styles.themeClient] = props.theme === TABS_THEMES.CLIENT,
            _a[styles.sizeS] = props.size === TABS_SIZES.S,
            _a[styles.sizeM] = props.size === TABS_SIZES.M,
            _a[styles.sizeL] = props.size === TABS_SIZES.L,
            _a), props.size || null, props.classNameWrapper || null), children: tabs }));
};
var Tabs$1 = React.memo(Tabs);

export { TABS_SIZES, TABS_THEMES, Tabs$1 as default };
//# sourceMappingURL=Tabs.js.map
